/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type { IAGStakePool, IAGStakePoolInterface } from "../IAGStakePool";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tickId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Harvested",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tickId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "ddays",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "agAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shareAmount",
        type: "uint256",
      },
    ],
    name: "Staked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tickId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "agAmount",
        type: "uint256",
      },
    ],
    name: "Unstaked",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tickId",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "revenueId",
        type: "uint32",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "harvest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "revenueId",
        type: "uint32",
      },
    ],
    name: "revenueInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalAGAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalInAmount",
            type: "uint256",
          },
        ],
        internalType: "struct IAGStakePool.RevenueInfo",
        name: "info",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "revenueTokenAddresses",
    outputs: [
      {
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tickId",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "revenueId",
        type: "uint32",
      },
    ],
    name: "revenueTokens",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct IAGStakePool.RevenueTokenAmount[]",
        name: "tokens",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "stakeDays",
        type: "uint16",
      },
    ],
    name: "stakeDays",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountEther",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "ddays",
        type: "uint16",
      },
    ],
    name: "staking",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tickId",
        type: "uint256",
      },
    ],
    name: "unstaking",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class IAGStakePool__factory {
  static readonly abi = _abi;
  static createInterface(): IAGStakePoolInterface {
    return new utils.Interface(_abi) as IAGStakePoolInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IAGStakePool {
    return new Contract(address, _abi, signerOrProvider) as IAGStakePool;
  }
}
